const apiUrl = "";

export default apiUrl;
